/**
 * Gates de permissao do CRM que ESPELHAM o backend (CRM-23).
 *
 * Botao que aparece e leva 403, ou some para quem o servidor aceitaria, e o
 * mesmo defeito visto dos dois lados: a tela decidindo por uma regra que nao
 * e a do servidor. Cada funcao aqui cita o portao que espelha — quem mudar o
 * backend muda aqui junto.
 */

export const PERMISSAO_LEAD_MOVER = "lead:mover";
export const PERMISSAO_LEAD_CRIAR = "lead:create";
export const PERMISSAO_PIPELINE_CONFIGURAR = "pipeline:configurar";

// EtapaPipeline.tipo da coluna de conversao: mover para ela grava o ganho.
export const TIPO_ETAPA_CONVERSAO = "FINALIZADO";

/**
 * Pode arrastar o card / trocar a etapa na Tabela / "Mover etapa" no cockpit.
 *
 * Espelha os dois portoes de POST /api/crm/leads/{id}/mover:
 *   - a view exige `lead:mover`;
 *   - `crm.services._ator_pode_mover`: com a regra
 *     `pipeline_permite_vendedor_mover` desligada, so `pipeline:configurar`.
 * Master passa sempre. Regras ainda nao carregadas contam como desligadas:
 * melhor esperar o pipeline chegar do que deixar arrastar e devolver 403.
 */
export function podeMoverLead(hasPermission, regras, isMaster) {
  if (isMaster) return true;
  if (!hasPermission(PERMISSAO_LEAD_MOVER)) return false;
  return (
    Boolean(regras?.pipeline_permite_vendedor_mover) ||
    hasPermission(PERMISSAO_PIPELINE_CONFIGURAR)
  );
}

/** Configurar pipeline e reordenar colunas (POST /pipeline/configurar, /etapas-pipeline/*). */
export function podeConfigurarPipeline(hasPermission, isMaster) {
  return Boolean(isMaster) || hasPermission(PERMISSAO_PIPELINE_CONFIGURAR);
}

/** "Novo lead" e "+ Adicionar" da coluna (POST /api/crm/leads). */
export function podeCriarLead(hasPermission, isMaster) {
  return Boolean(isMaster) || hasPermission(PERMISSAO_LEAD_CRIAR);
}

/**
 * Ganho e perdido encerram o lead: `mover_lead` recusa os dois (CRM-07).
 * Perdido volta por "Reverter perda"; ganho nao muda mais de etapa.
 */
export function leadEncerrado(lead) {
  if (!lead) return true;
  return Boolean(lead.perdido_em || lead.ganho_em);
}

/**
 * Soltar o card (ou escolher a etapa) chama o backend? Etapa diferente, sim.
 * A mesma etapa so tem efeito na coluna de conversao com o lead ainda sem
 * ganho: `mover_lead` aplica o ganho que ficou faltando (FORM-20 — lead que
 * entrou em "Convertido" por formulario ou por seed antigo).
 */
export function moverTemEfeito(etapaAtualId, etapaDestino, lead) {
  if (!etapaDestino) return false;
  if (String(etapaAtualId) !== String(etapaDestino.id)) return true;
  return etapaDestino.tipo === TIPO_ETAPA_CONVERSAO && !lead?.ganho_em;
}
